import api from '../services/api';
import Swal from 'sweetalert2';

export default function Terapias() {
  const container = document.createElement('div');
  container.className = 'content';

  // Header
  const header = document.createElement('div');
  header.className = 'card';
  header.innerHTML = `<h2>Terapias Executadas</h2>`;
  container.appendChild(header);

  // Actions
const actions = document.createElement('div');
actions.className = 'card inline';
actions.innerHTML = `
  <input id="filtroPaciente" class="form-input" placeholder="Filtrar por paciente..." />
  <input id="filtroSerie" class="form-input" placeholder="Filtrar por nº série..." />
  <input id="filtroUsuario" class="form-input" placeholder="Filtrar por usuário..." />
  <button id="btnCarregarTerapia" class="btn btn-sm">Carregar</button>
`;
container.appendChild(actions);

  // Grid
  const grid = document.createElement('div');
  grid.className = 'card';
  grid.innerHTML = `
    <table class="table">
      <thead>
        <tr>
          <th>Paciente</th>
          <th>Tipo Terapia</th>
          <th>Usuario</th>
          <th>Data</th>
          <th>Mobi Light</th>
          <th>Duração</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody id="tbTerapias"></tbody>
    </table>
  `;
  container.appendChild(grid);

  async function carregar() {
    const filtroPaciente = document.querySelector('#filtroPaciente')?.value || '';
    const filtroSerie = document.querySelector('#filtroSerie')?.value || '';
    const filtroUsuario = document.querySelector('#filtroUsuario')?.value || '';

  const res = await api.get('/terapiasexecutadas', { 
    params: { filtroPaciente, filtroSerie, filtroUsuario } 
  });
    
    const tbody = grid.querySelector('#tbTerapias');
    tbody.innerHTML = res.data.map(t => `
      <tr>
        <td>${t.paciente_nome}</td>
        <td>${t.tipo_terapia}</td>
        <td>${t.nome_usuario}</td>
        <td>${new Date(t.data).toLocaleString()}</td>
        <td>${t.numero_serie}</td>
        <td>${t.tempoexecutado || 0}</td>
        <td>
          <button class="btn btn-sm view" data-id="${t.cod_teparia}">
            <i class="fa-solid fa-eye"></i> Visualizar
          </button>
        </td>
      </tr>
    `).join('');
    bind();
  }

  function bind() {
    grid.querySelectorAll('.view').forEach(b =>
      b.onclick = () => detalhes(b.getAttribute('data-id'))
    );
  }
async function detalhes(id) {
  const t = (await api.get('/terapiasexecutadas')).data.find(x => x.cod_teparia === id);

  const lat = t.latitude;
  const lng = t.longitude;
  const mapsLink = (lat && lng) ? `https://www.google.com/maps?q=${lat},${lng}` : null;

  Swal.fire({
    title: 'Detalhes da Terapia',
    html: `
      <div style="text-align:left;">
        <p><b>Paciente:</b> ${t.paciente_nome}</p>
        <p><b>Angulo inicial:</b> ${t.anguloinicial}</p>
        <p><b>Angulo final:</b> ${t.angulofinal}</p>
        <p><b>Tipo Terapia:</b> ${t.tipo_terapia}</p>
        <p><b>Mobi Light:</b> ${t.numero_serie}</p>
        <p><b>Data:</b> ${new Date(t.data).toLocaleString()}</p>
        <hr/>
        <p><b>Tempo Definido:</b> ${t.tempodefinido || 0}</p>
        <p><b>Tempo Executado:</b> ${t.tempoexecutado || 0}</p>
        <p><b>Largura Pulso:</b> ${t.largura_pulso || 0}</p>
        <p><b>Frequência:</b> ${t.frequencia || 0}</p>
        <p><b>Intensidades:</b> 
          [${t.intensidade_canal_1}, ${t.intensidade_canal_2}, ${t.intensidade_canal_3}, 
           ${t.intensidade_canal_4}, ${t.intensidade_canal_5}, ${t.intensidade_canal_6}]
        </p>
        <p><b>Localização:</b> 
          ${mapsLink 
            ? `<a href="${mapsLink}" target="_blank">
                 <i class="fa-solid fa-map-location-dot"></i> ${lat}, ${lng}
               </a>` 
            : '-'}
            </p>
          <p><b>Alterações:</b> 
            
              <a href="#" id="linkDetalhes">Ver detalhes</a>
            
            
          </div>
        `,
        confirmButtonText: 'Fechar',
        didOpen: () => {
          document.getElementById('linkDetalhes').onclick = async (e) => {
            e.preventDefault();
            const res = await api.get(`/terapiasexecutadasdetalhe/${id}`);
            const detalhes = res.data;

            Swal.fire({
      title: 'Histórico de Detalhes',
      html: `
        <div style="max-height:600px; overflow-y:auto; text-align:left;">
          <table class="table" style="width:100% !important; border-collapse:collapse !important;">
            <thead>
              <tr>
                <th style="width:160px !important;">Data</th>
                <th style="width:120px !important;">Carga</th>
                <th style="width:120px !important;">Tempo Executado</th>
                <th style="width:120px !important;">Largura Pulso</th>
                <th style="width:120px !important;">Frequência</th>
                <th style="width:120px !important;">Ângulos</th>
                <th style="width:220px !important;">Intensidades</th>
              </tr>
            </thead>
            <tbody>
              ${detalhes.map(d => {
                const mapsLink = (d.latitude && d.longitude)
                  ? `<a href="https://www.google.com/maps?q=${d.latitude},${d.longitude}" target="_blank">
                      <i class="fa-solid fa-map-location-dot"></i>
                    </a>`
                  : '-';
                return `
                  <tr>
                    <td>${new Date(d.data).toLocaleString()}</td>
                    <td>${d.carga || '-'}</td>
                    <td>${d.tempodefinido || 0}</td>
                    <td>${d.largura_pulso || 0}</td>
                    <td>${d.frequencia || 0}</td>
                    <td>${d.anguloinicial || 0}° / ${d.angulofinal || 0}°</td>
                    <td>[${d.intensidade_canal_1}, ${d.intensidade_canal_2}, ${d.intensidade_canal_3},
                        ${d.intensidade_canal_4}, ${d.intensidade_canal_5}, ${d.intensidade_canal_6}]</td>
                  </tr>
                `;
              }).join('')}
            </tbody>
          </table>
        </div>
      `,
  width: 1200,
  confirmButtonText: 'Fechar',
  confirmButtonColor: '#28a745',
    customClass: {
    popup: 'detalhes-popup', // 👈 aplica estilo específico
  },
  confirmButtonText: 'Fechar'
});


      };
    }
  });
}

const btn = actions.querySelector('#btnCarregarTerapia');
btn.addEventListener('click', carregar);


  carregar();
  return container;
}
